import { BRIDGE_ERROR, BRIDGE_ERROR_MESSAGE, BRIDGE_LIMITS } from '../constants/bridge';

const KNOWN_CODES = new Set(Object.values(BRIDGE_ERROR));

export function isKnownErrorCode(code) {
    return KNOWN_CODES.has(code);
}

export function ok(value) {
    return { ok: true, value };
}

export function fail(code, message) {
    const safeCode = KNOWN_CODES.has(code) ? code : BRIDGE_ERROR.FAILED;
    const safeMessage = typeof message === 'string' && message.trim()
        ? message.trim().slice(0, BRIDGE_LIMITS.MESSAGE_MAX)
        : BRIDGE_ERROR_MESSAGE[safeCode];
    return { ok: false, error: { code: safeCode, message: safeMessage } };
}

export function isResult(candidate) {
    if (!candidate || typeof candidate !== 'object') return false;
    if (candidate.ok === true) return 'value' in candidate;
    if (candidate.ok === false) {
        return !!candidate.error && typeof candidate.error.code === 'string';
    }
    return false;
}
